export default{
    REPORTGENERICCONFIGTABLE: "/report/generic/config/table",
    REPORTGENERICORGLIST: "/report/generic/org/list",
    REPORTGENERIUSERLIST: "/report/generic/user/list",
    DELREPORTGENERIUSERLIST: "/report/generic/del/user",
    REPORTGENERICORGRTORG: "/report/generic/org/rtOrg",
    REPORTGENERICORG: "/report/generic/org",

    REPORTGENERICPROJECTRTPROJECT: "/report/generic/project/rtProject",
    REPORTGENERICPROJECTLIST: "/report/generic/project/list",
    REPORTGENERICPROJECT: "/report/generic/project",
    REPORTGENERICSQL: "/report/generic/sql",
    REPORTGENERICCOLUMN: "/report/generic/column",
    REPORTGENERICCOLUMNSEQ: "/report/generic/column/seq",
    REPORTGENERICUSER: "/report/generic/user",
    SAVEREPORTGENERICUSER: "/report/generic/saveRtUser",
    REPORTGENERICTEMPLATELIST: "/report/generic/template/list",
    REPORTGENERICMENU: "/report/generic/menu",
    REPORTGENERICQUERY: "/report/generic/query",
    REPORTGENERICSEARCHABLEFIELD: "/report/generic/searchable/field",
    REPORTGENERICTEMPLATE: "/report/generic/template",
    REPORTGENERICTEMPLATEDELETION: "/report/generic/template/deletion",
    REPORTGENERICTEMPLATEDROPDOWNALL: "/report/generic/template/dropdown/all",
    REPORTGENERICCONFIGTABLEDELETION: "/report/generic/config/table/deletion",
    REPORTGENERICPUBLISH: "/report/generic/publish" ,
    REPORTGENERICCONFIGCOPY: "/report/generic/config/copy",
    REPORTRREPORT: "/report/generic/reportSetting/sendToProd",
    REPORTGENERICEXPORT: "/report/generic/export",
    REPORTGENERICCONFIGDATASOURCE: "/report/generic/config/dataSource",
    REPORTGENERICDELDATASOURCE: "/report/generic/del/dataSource",
    REPORTGENERICCONFIGCONTION: "/report/generic/config/condition",
    REPORTGENERICDELCONFIGCONDITION: "/report/generic/del/config/condition",
    REPORTGENERICCONFIGTML: "/report/generic/config/template",
    REPORTGENERICCONFIGIREPORT: "/report/generic/config/ireport",
    REPORTGENERICCONFIGDOWNLOAD: "/report/generic/config/download",
    REPORTGENERICCONFIGUPLOAD: "/report/generic/config/upload",
    REPORTGENERICDELCONFIGIREPORT: "/report/generic/del/config/ireport",
    REPORTGENERICCONFIGIREPORTDS: "/report/generic/config/ireport/ds",
    REPORTGENERICDELCONFIGIREPORTDS: "/report/generic/del/config/ireport/ds",
    REPORTGENERICCONFIGIREPORTIMAGE: "/report/generic/config/ireport/image",
    REPORTGENERICCONFIGIMAGEUPLOAD:"/report/generic/config/image/upload",
    REPORTGENERICDELCONFIGIREPORTIMAGE: "/report/generic/del/config/ireport/image",
    REPORTGENERICCONFIGIMAGEDOWNLOAD: "/report/generic/config/image/download",
    REPORTGENERICDROPADVANCESEARCH: "/report/generic/dropDown/advance/search",
	REPORTGENERICCONDDATATYPEDROPDOWN: "/report/generic/cond/dataType/dropdown",
    REPORTGENERICADVANCESEARCH: "/report/generic/advance/search",
    REPORTGENERICDELADVANCESEARCH: "/report/generic/del/advance/search",
    REPORTGENERICCONFIGJASPERUPLOAD:"/report/generic/config/jasper/upload",
    REPORTGENERICCONFIGJASPEPRDOWNLOAD: "/report/generic/config/jasper/download",
    REPORTGENERICCONFIGJRXMLUPLOAD: "/report/generic/config/jrxml/upload",
    REPORTGENERICCONFIGJRXMLDOWNLOAD: "/report/generic/config/jrxml/download",
    REPORTGENERICDOWNLOADXML: "/report/generic/download/xml",
    SCHEDULSAVE: "/schedule",
    SCHEDULEBATCH: "/schedule/batch",
    SCHEDULEBATCHSAVE: "/schedule/batch/save",
    SAVEREPORTPRINTSERVICES: "/report/generic/config/ireport/savePrintServices",
    GETREPORTPRINTSERVICES: "/report/generic/config/ireport/getPrintServices",
    DELETEPRINTSERVICES: "/report/generic/config/ireport/deletePrintServices",
    GETPRINTERLIST: "/report/generic/config/ireport/getPrinterList",
    GETUSERNAME: "/report/generic/config/ireport/getUserName",
    GETPRINTFILELIST:"/config/ireport/getPrintFileList",
    AUTOPRINT:"/config/ireport/autoPrint",
    AUTOPRINTPDF:"/config/ireport/autoPrintPdf",
    AUTOPRINTCHECKCOMPLETE:"/config/ireport/autoPrintCheckComplete",
    PRINTVIEWFILE:"/printViewFile",
}